import * as React from 'react';
import { IFluidObject } from '@fluidframework/core-interfaces';
import { ExternalContainer, TokenProvider, SettingsProvider } from '@fluidx/office-fluid-types';
import { Locale, LocaleDirection } from '@fluidx/utilities';
import { HostUxStrings } from '../../stringTypes/HostUxStrings';

interface ComponentUXContextProviderProps {
  /** Loaded container */
  container?: ExternalContainer;

  /** Loaded component */
  component?: IFluidObject;

  /** Localized string table */
  stringTable: HostUxStrings;

  /** Token provider */
  tokenProvider?: TokenProvider;

  /** Host localization */
  localization: {
    /** Host locale */
    locale: Locale;

    /** Host UI locale direction */
    localeDirection?: LocaleDirection;
  };

  /** Settings provider */
  settingsProvider?: SettingsProvider;
}

export const ComponentUXContext = React.createContext<ComponentUXContextProviderProps | null>(null);

export const ComponentUXContextProvider = React.memo(
  (props: ComponentUXContextProviderProps & { children: React.ReactNode }) => {
    const { children, ...contextValue } = props;

    return <ComponentUXContext.Provider value={contextValue}>{children}</ComponentUXContext.Provider>;
  }
);
